import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ApiResourceService } from '../../apiResource/apiResource.service';
import { IAirGetQuotedAvailabilityRequest } from "../model/booking/air/IAirQuotedAvailability";
import { IAirQuotedAvailabilityResponse } from "../model/booking/air/IAirQuotedAvailabilityResponse";
import { flatMap } from "rxjs/internal/operators";
import { ResponseForConvertOfferAfx2jsonType } from "@afidium/ts-facade";
import { AirQuoteMappingService } from "libraries/service/resources/airQuote/air-quote-mapping.service";
import { LanguageService } from "libraries/service/language/language.service";

export interface IServiceQuality {
    code: EServiceQualityEnum;
    label: string;
    match: boolean;
    message: string[];
}

export enum EServiceQualityEnum {
    OSI_TO = "OSI_TO",
    APIS = "APIS",
    MCT = "MCT",
}

const URL_AIR: string = 'air';
const URL_QUOTES: string = 'quotes';
const URL_GQA: string = 'quoteOffer';
const URL_SERVICE: string = 'services';

@Injectable()
export class AirQuoteResourceService {

    constructor(
        private readonly apiResourceService: ApiResourceService,
        private readonly airQuoteMappingService: AirQuoteMappingService,
        private readonly languageService: LanguageService,
    ) {
    }

    public fetchQuotedAvailability(body: IAirGetQuotedAvailabilityRequest, target: string, offerAlternativePriceXId?: string)
        : Observable<IAirQuotedAvailabilityResponse> {


        return this.postGetQuotedAvailability(
            body,
            target
        )
            .pipe(
                flatMap(
                    (response: ResponseForConvertOfferAfx2jsonType): Observable<IAirQuotedAvailabilityResponse> => {
                        const mappedResponse: IAirQuotedAvailabilityResponse = this.airQuoteMappingService
                            .mapGqaNewToOld(response, offerAlternativePriceXId) as unknown as IAirQuotedAvailabilityResponse;
                        return of(mappedResponse);
                    }
                )
            );
    }

    public postGetQuotedAvailability(body: IAirGetQuotedAvailabilityRequest, target: string): Observable<ResponseForConvertOfferAfx2jsonType> {

        const languageCode: string = this.languageService.getUserLanguage();

        return this.apiResourceService.postOne<IAirGetQuotedAvailabilityRequest, ResponseForConvertOfferAfx2jsonType>(
            this.apiResourceService.getApiUrl(URL_AIR, URL_QUOTES, URL_GQA),
            {
                ...body,
                languageCode
            },            {},
            {target}
        );
    }
    public postGetQuotedAvailabilityWithService(body: IAirGetQuotedAvailabilityRequest, target: string): Observable<ResponseForConvertOfferAfx2jsonType> {

        const languageCode: string = this.languageService.getUserLanguage();

        return this.apiResourceService.postOne<IAirGetQuotedAvailabilityRequest, ResponseForConvertOfferAfx2jsonType>(
            this.apiResourceService.getApiUrl(URL_AIR, URL_QUOTES, URL_GQA, URL_SERVICE),
            {
                ...body,
                languageCode
            },            {},
            {target}
        );
    }
}
